import * as React from 'react'

export const IconPlay = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.25 10.719c.969.594.969 2 0 2.594l-11 6.5C6.25 20.405 5 19.688 5 18.5v-13c0-1.281 1.344-1.813 2.25-1.281l11 6.5Z'
      fill='currentColor'
    />
  </svg>
)
